export {
    default as RutPasaporteField,
    RutPasaporteFieldProps,
    RutPasaporteInput,
    RutPasaporteInputProps,
    RutDatos,
    PasaporteDatos,
    RutPasaporteDatos,
} from './RutPasaporte';
export { default as Rut, RutProps } from './componentes/Rut/';
export { default as Pasaporte, PasaporteProps } from './componentes/Pasaporte/';

export { esValido as rutEsValido } from './componentes/Rut/rut';



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/RutPasaporte/index.ts